// src/components/TrustStrip.jsx
export default function TrustStrip() {
  const items = [
    {
      icon: '🚚',
      title: 'Livraison rapide',
      text: '24–72h sur Lomé et ses environs.',
    },
    {
      icon: '📱',
      title: 'Paiement Mobile Money',
      text: 'PayGate Flooz / TMoney ou paiement à la livraison.',
    },
    {
      icon: '✅',
      title: 'Vendeurs vérifiés',
      text: 'Sélectionnés et suivis par l’équipe GoShop.',
    },
    {
      icon: '💬',
      title: 'Support WhatsApp',
      text: 'Nous répondons rapidement à vos questions.',
    },
  ]

  return (
    <section className="mb-4">
      <div className="card-modern p-3 trust-strip">
        <div className="row row-cols-2 row-cols-md-4 g-3">
          {items.map((it, i) => (
            <div className="col d-flex" key={i}>
              <div className="me-2 fs-4">{it.icon}</div>
              <div>
                <div className="fw-semibold small">{it.title}</div>
                <div className="text-muted small">{it.text}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
